import axios from "axios";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import * as Yup from 'yup';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom'
import React, { useState, useRef } from "react";
import { GoUnverified } from "react-icons/go";
import { RotatingLines } from 'react-loader-spinner'


const ForgotPassword = () => {
  const [userId,setUserId]=useState('')
  const [loadingVerifyEmail,setLoadingVerifyEmail]=useState(false) 
  const [loadingSendOtp,setLoadingSendOtp]=useState(false) 
  const [hide,setHide]=useState(false)
  const [reSend, setResend] = useState(false);
  const [timer, setTimer] = useState(120);
  const [showOtp,setShowOtp]=useState(false)
  const [showPassword,setShowPassword]=useState(false)
  const [loading, setLoading] = useState(false);
  const [viewPassword, setViewPassword] = useState(false);
  const navigate = useNavigate();

  const validationSchema = Yup.object({
    email: Yup.string().email('Invalid email format').required('Email is required'),
    otp1: Yup.string().required('OTP is required'),
    otp2: Yup.string().required('OTP is required'),
    otp3: Yup.string().required('OTP is required'),
    otp4: Yup.string().required('OTP is required'),
    password: Yup.string()
    .min(8, 'Password must be at least 8 characters long')
    .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
    .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .matches(/[0-9]/, 'Password must contain at least one number')
    .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character')
    .required('New password is required'),
  });


  const timers = ()=>{
    const countdown = setInterval(() => {
      setTimer((prevTimer) => (prevTimer > 0 ? prevTimer - 1 : 0));
    }, 1000);
    if(timer===0){
      clearInterval(countdown);
    }
  }

  const inputRefs = {
    otp1: useRef(null),
    otp2: useRef(null),
    otp3: useRef(null),
    otp4: useRef(null),
  };

  const focusNextInput = (fieldName) => {
    switch (fieldName) {
      case "otp1":
        inputRefs.otp2.current.focus();
        break;
      case "otp2":
        inputRefs.otp3.current.focus();
        break;
      case "otp3":
        inputRefs.otp4.current.focus();
        break;
      default:
        break;
    }
  };

  const focusPrevInput = (fieldName) => {
    switch (fieldName) {
      case "otp2":
        inputRefs.otp1.current.focus();
        break;
      case "otp3":
        inputRefs.otp2.current.focus();
        break;
      case "otp4":
        inputRefs.otp3.current.focus();
        break;
      default:
        break;
    }
  };

  const handlePaste = (e, setFieldValue) => {
        const pasteData = e.clipboardData.getData('text');
        if (pasteData.length === 4) {
          const otpFields = ['otp1', 'otp2', 'otp3', 'otp4'];
          otpFields.forEach((field, index) => {
            setFieldValue(field, pasteData[index]);
          });
        }
        e.preventDefault();
      };

  const updateViewPassword=()=>{
    setViewPassword(!viewPassword)
  }

  const sendOtpwithEmail=async(value)=>{
    setResend(true);
    setLoadingSendOtp(true)
    try {
      const data = {
        email: value
      };
      const response = await axios.post(
        "https://bankdata.inclineanalytics.com/api/users/forgot_password",
        data
      );
      if (response.data.success) {
        setTimer(120)
        timers()
        toast.success(response.data.message);
        setShowOtp(true)
      }
    } catch (error) {
      console.error("Error sending otp:", error);
      toast.error(error.response.data.message);
    }finally{
        setResend(false);
        setLoadingSendOtp(false)
    }
  }

  const verifyEmailwithOtp=async(values)=>{
    setLoadingVerifyEmail(true)
    try {
      const data = {
        email: values.email,
        otp:values.otp,
      };
      const response = await axios.post(
        "https://bankdata.inclineanalytics.com/api/users/verify-otp",
        data
      );
      if (response.data.success) {
        setUserId(response.data.data.userId)
        toast.success(response.data.message);
        setShowPassword(true)
        setTimer(0)
        setShowOtp(false)
        setHide(true)
      }
    } catch (error) {
      console.error("Error sending otp:", error);
      toast.error(error.response.data.message);
    }finally{
    setLoadingVerifyEmail(false)
    }
  }

  const updatePassword=async(values)=>{
    setLoading(true)
    try {
      const data = {
        email: values.email,
        otp:values.otp,
        userId:userId,
        password:values.password,
      };
      const response = await axios.post(
        "https://bankdata.inclineanalytics.com/api/users/update_password",
        data
      );
      if (response.data.success) {
        toast.success(response.data.message);
        setTimeout(()=>{
            navigate('/')
        },2000)
      }
    } catch (error) {
      console.error("Error sending otp:", error);
      toast.error(error.response.data.message);
    }finally{
    setLoading(false)
    }
  }

  return (
    <div className ="bg-[#001f3f] min-h-screen max-h-fit p-5 text-[#fff]">
      <ToastContainer/>
      <div className="">
        <div>
            <a href="/" className="inline-block">
                <img src="https://www.inclineanalytics.com/wp-content/uploads/2020/04/Incline-Analytics5-01.png" alt="Incline Analytics Logo" style={{ width: "150px", height: "auto" }} />
            </a>
        </div>
        <div className="space-x-16 m-10 flex justify-center items-center">
                <div className="lg:w-[45vw] md:w-3/4">
                    <Formik
                        initialValues={{ email: '', otp1: "", otp2: "", otp3: "", otp4: "",password:'', }}
                        validationSchema={validationSchema}
                        onSubmit={(values)=>{
                            const data = {
                                email: values.email,
                                otp: `${values.otp1}${values.otp2}${values.otp3}${values.otp4}`,
                                password:values.password,
                            };
                            updatePassword(data)
                            console.log(data)
                        }}
                    >
                        {({ values, errors, touched, setFieldValue }) => (
                        <Form className="bg-white p-8 rounded-lg shadow-md">
                            <h1 className="text-[#ff6f61] text-3xl font-bold mb-2">Forgot Password</h1>
                            <div className="flex flex-col justify-center items-center flex-wrap">
                            {!hide &&
                            <div className="mb-4 h-[100px] min-w-[200px] lg:w-1/2 p-4">
                            <label htmlFor="email" className="block text-left text-gray-700 text-lg font-bold mb-2">
                            Email
                            </label>
                            <Field
                                type="email"
                                id="email"
                                name="email"
                                className="mt-1 block w-full p-2 pl-4 border rounded-lg text-black border-[#ff6f61] focus:border-[#ff6f61] focus:border-[3px] focus:outline-none"
                            />
                            <ErrorMessage name="email" component="div" className=" text-left ml-2 text-red-500 text-sm mt-1" />
                            </div>}
                            <div className="flex justify-end w-full">
                            {!showOtp && !hide && 
                                <button onClick={()=>{
                                    const validateEmail = (email) => {
                                        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                        return regex.test(email);
                                      };           
                                      const data = validateEmail(values.email)   
                                      if(data){
                                        sendOtpwithEmail(values.email)
                                      }                     
                                }} type="button" className="lg:mr-16 text-[#ffffff] p-1 pr-2 pl-2 rounded-lg flex items-center bg-[#ff6f61]">{loadingSendOtp ? (
                                  <div className="flex items-center">
                                    <div
                                      className="spinner"
                                      style={{
                                        border: '2px solid rgba(255, 255, 255, 0.3)',
                                        borderRadius: '50%',
                                        borderTop: '2px solid #fff',
                                        width: '20px',
                                        height: '20px',
                                        animation: 'spin 1s linear infinite',
                                        marginRight: '10px',
                                      }}
                                    />
                                    Sending...
                                  </div>
                                ) : (
                                  'Send OTP'
                                )}
                                </button>}
                            </div>
                            {showOtp && <div className="flex justify-end w-full">
                                <div className="lg:mr-12 flex justify-center items-center">
                                {reSend &&                                
                                <div className="mt-2 mr-2"><RotatingLines
                                  strokeColor="#ff6f61"
                                  strokeWidth="5"
                                  animationDuration="0.75"
                                  width="20"
                                  visible={true}
                              /></div>}
                                <button onClick={()=>{
                                 const validateEmail = (email) => {
                                    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                    return regex.test(email);
                                  };           
                                  const data = validateEmail(values.email)   
                                  if(data){
                                    sendOtpwithEmail(values.email)
                                  }         
                            }} type="button" className={`text-gray-600 mt-2 mr-1 ${timer===0 && "text-gray-400 hover:underline"}`} disabled={timer > 0}>Re-send OTP
                            </button> 
                            {timer > 0 && <span className="text-gray-500 mt-2">({Math.floor(timer / 60)}:{(timer % 60).toString().padStart(2, '0')})</span>}
                            </div> </div>}
                            {showOtp &&
                    
                      <div className="flex justify-center items-center w-full">                        
                          <div className="mb-4 h-[100px] min-w-[200px] p-4 flex flex-col items-center justify-center lg:flex lg:justify-between lg:items-center">
                            <label htmlFor="otp" className="block text-left w-full text-gray-700 text-lg font-bold mb-2">
                              OTP
                            </label>
                            <div className="flex gap-2">
                              <Field
                                type="text"
                                id="otp1"
                                name="otp1"
                                maxLength="1"
                                className="w-12 h-12 text-center text-black border border-[#ff6f61] rounded-lg focus:outline-none focus:border-[#ff6f61] focus:border-[3px]"
                                innerRef={inputRefs.otp1}
                                onPaste={(e) => handlePaste(e, setFieldValue)}
                                onKeyUp={(e) => {
                                  if (e.key === "Backspace") {
                                    focusPrevInput("otp1");
                                  } else if (e.target.value.length === 1) {
                                    focusNextInput("otp1");
                                  }
                                }}
                              /> 
                              <Field
                                type="text"
                                id="otp2"
                                name="otp2"
                                maxLength="1"
                                className="w-12 h-12 text-center text-black border border-[#ff6f61] rounded-lg focus:outline-none focus:border-[#ff6f61] focus:border-[3px]"
                                innerRef={inputRefs.otp2}
                                onKeyUp={(e) => {
                                  if (e.key === "Backspace") {
                                    focusPrevInput("otp2");
                                  } else if (e.target.value.length === 1) {
                                    focusNextInput("otp2");
                                  }
                                }}
                              />
                              <Field
                                type="text"
                                id="otp3"
                                name="otp3"
                                maxLength="1"
                                className="w-12 h-12 text-center text-black border border-[#ff6f61] rounded-lg focus:outline-none focus:border-[#ff6f61] focus:border-[3px]"
                                innerRef={inputRefs.otp3}
                                onKeyUp={(e) => {
                                  if (e.key === "Backspace") {
                                    focusPrevInput("otp3");
                                  } else if (e.target.value.length === 1) {
                                    focusNextInput("otp3");
                                  }
                                }}
                              />
                              <Field
                                type="text"
                                id="otp4"
                                name="otp4"
                                maxLength="1"
                                className="w-12 h-12 text-center text-black border border-[#ff6f61] rounded-lg focus:outline-none focus:border-[#ff6f61] focus:border-[3px]"
                                innerRef={inputRefs.otp4}
                                onKeyUp={(e) => {
                                  if (e.key === "Backspace") {
                                    focusPrevInput("otp4");
                                  } else if (e.target.value.length === 1) {
                                    focusNextInput("otp4");
                                  }
                                }}
                              />
                            </div>
                            <ErrorMessage name="otp4" component="div" className=" text-left ml-2 text-red-500 text-sm mt-1" />
                          </div>    
                      </div>
                  }
                            <div className="flex justify-end w-full">
                            {showOtp &&  
                                <button onClick={()=>{
                                    const data = {
                                        email:values.email,
                                        otp:`${values.otp1}${values.otp2}${values.otp3}${values.otp4}`,
                                    }                                    
                                      verifyEmailwithOtp(data)                                                  
                                }} disabled={!values.otp1 || !values.otp2 || !values.otp3 || !values.otp4} type="button" className="text-[#ffffff] lg:mr-12 p-1 pr-2 pl-2 rounded-lg flex items-center bg-[#ff6f61]">{loadingVerifyEmail ? (
                                  <div className="flex items-center">
                                    <div
                                      className="spinner"
                                      style={{
                                        border: '2px solid rgba(255, 255, 255, 0.3)',
                                        borderRadius: '50%',
                                        borderTop: '2px solid #fff',
                                        width: '20px',
                                        height: '20px',
                                        animation: 'spin 1s linear infinite',
                                        marginRight: '10px',
                                      }}
                                    />
                                    Verifying...
                                  </div>
                                ) : (
                                  <>Verify email <span className="ml-2"><GoUnverified /></span></>
                                )}
                                </button>}
                            </div>
                            {showPassword&&
                            <div className="mb-4 h-[100px] min-w-[200px] lg:w-1/2 p-4">
                            <label htmlFor="password" className="block text-left text-gray-700 text-lg font-bold mb-2">
                                New Password
                            </label>
                            <div className="mt-1 w-full flex p-2 pl-4 border rounded-lg text-black border-[#ff6f61] focus-within:border-[3px]">
                            <Field
                                type={`${viewPassword? 'text':'password'}`}
                                id="password"
                                name="password"
                                className="text-black w-full focus:outline-none"
                            />
                            <button type='button' className="text-black mr-2 text-xl" onClick={updateViewPassword}>{viewPassword? <FaEye />:<FaEyeSlash />}</button>
                            </div>
                            <ErrorMessage name="password" component="div" className="text-left ml-2 text-red-500 text-sm mt-1" />
                            </div>}
                            </div>
                            {hide &&
                            <button
                            type="submit"
                            className="bg-[#ff6f61] mt-4 text-white py-2 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            >
                            {loading? 
                              <div className="flex justify-center items-center">
                                <div className="spinner" style={{
                                  border: "2px solid rgba(255, 255, 255, 0.3)",
                                  borderRadius: "50%",
                                  borderTop: "2px solid #fff",
                                  width: "20px",
                                  height: "20px",
                                  animation: "spin 1s linear infinite",
                                  marginRight: "10px"
                                }} />
                                Updating...
                              </div>:"Update"}
                            </button>}
                        </Form>
                        )}
                    </Formik>
                </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
